// ** React Imports
import { useState, useEffect } from "react";

// ** MUI Imports
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  MenuItem,
  FormLabel,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// ** Icon Imports
import Icon from "components/icon";

// ** Custom Component Imports
import CustomTextField from "components/mui/text-field";

// ** Toast Imports
import 'react-toastify/dist/ReactToastify.css';

// ** Logic Imports
import { useAddMaterialTypeLogic } from "../logic/AddMaterialTypeLogic";
import { useInventoryPermission } from "../permissions/InventoryPermissions";

const AddMaterialType = ({ open, handleClose, setLoading, selectedMaterialType }) => {
  //#region Permissions
  const { InventoryPermissionProps } = useInventoryPermission();
  const {
    hasTypeCatalogSavePermission,
  } = InventoryPermissionProps;
  //#endregion Permissions

  const {
    materialTypeForm,
    errors,
    handleInputChange,
    handleSaveMaterialType,
    resetForm
  } = useAddMaterialTypeLogic({ handleClose, setLoading, open, selectedMaterialType });

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle
        sx={{
          borderBottom: "1px solid #D9D9D9",
          paddingBottom: "20px !important",
        }}
      >
        <Box>
          <Typography variant="h4" fontWeight="bold">
            {selectedMaterialType ? "Edit Material Type" : "Create New Material Type"}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={5}>
          <Grid item xs={12} md={7}>
            <CustomTextField
              fullWidth
              required
              label="Material Type"
              placeholder="Enter the material type name"
              name="typeName"
              value={materialTypeForm.typeName}
              onChange={handleInputChange}
              error={Boolean(errors.typeName)}
              helperText={errors.typeName}
            />
          </Grid>
          <Grid item xs={12} md={7}>
            <CustomTextField
              fullWidth
              multiline
              rows={2}
              label="Description"
              placeholder="Enter a brief description"
              name="description"
              value={materialTypeForm.description}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "20px 24px !important",
          boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`,
          zIndex: 1,
        }}
        className="dialog-actions-dense"
      >
        <Box>
          <Button variant="contained" color="info" onClick={handleClose}>
            Cancel
          </Button>
        </Box>
        <Box>
          <Button 
            variant="contained" 
            color="main" 
            disabled={!hasTypeCatalogSavePermission} 
            {...(hasTypeCatalogSavePermission && {
              onClick: () => handleSaveMaterialType()
            })}
          >
            {selectedMaterialType ? "Save Changes" : "Save Material Type"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default AddMaterialType;